(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3253],{

/***/ 55613:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./components/common/Layout/index.js + 26 modules
var Layout = __webpack_require__(19738);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./common/data/trustpilot/data.json
var trustpilot_data = __webpack_require__(54356);
// EXTERNAL MODULE: ./common/hooks/useResizeScreenModified.js
var useResizeScreenModified = __webpack_require__(77450);
// EXTERNAL MODULE: ./components/atoms/Img/index.js
var Img = __webpack_require__(97464);
// EXTERNAL MODULE: ./components/atoms/LinkRouter/index.js
var LinkRouter = __webpack_require__(27597);
// EXTERNAL MODULE: ./components/atoms/Title/index.js
var Title = __webpack_require__(31741);
// EXTERNAL MODULE: ./components/molecules/FormNewsletter/index.js
var FormNewsletter = __webpack_require__(32314);
// EXTERNAL MODULE: ./components/organisms/AboutUs/index.js
var AboutUs = __webpack_require__(63353);
// EXTERNAL MODULE: ./components/organisms/Banner/index.js + 6 modules
var Banner = __webpack_require__(47447);
// EXTERNAL MODULE: ./components/organisms/IndustryNewsInsights/index.js
var IndustryNewsInsights = __webpack_require__(93008);
// EXTERNAL MODULE: ./components/organisms/OurPartners/index.js + 3 modules
var OurPartners = __webpack_require__(90895);
// EXTERNAL MODULE: ./components/organisms/TrustpilotFeedBack/index.js + 1 modules
var TrustpilotFeedBack = __webpack_require__(91630);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/templates/sg/index.js
















var Component = function Component(_ref) {
  var posts = _ref.posts,
      data = _ref.data;

  var _useState = (0,react.useState)(""),
      companyName = _useState[0],
      setCompanyName = _useState[1];

  var handleInput = function handleInput(event) {
    setCompanyName(event.target.value);
  };

  var handleSubmit = function handleSubmit() {
    window.location.href = "/onboarding/register?country_id=191&company_name=".concat(companyName);
  };

  var _useState2 = (0,react.useState)("DESKTOP"),
      screen = _useState2[0],
      setScreen = _useState2[1];

  (0,useResizeScreenModified/* default */.Z)(setScreen);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Banner/* default */.Z, {
        minHeightBanner: "banner-min-h-600",
        title: "Setting up your <br/> Singapore business <br/> doesn't need to be <br/> complicated.",
        description: "We start your Singapore company in hours, take care of administration and compliance nuances.",
        bgColor: "bg-bbc-gradient-12 bg-[length:180%_180%] animate-[gradientAnimation_10s_ease_infinite]",
        leftClassName: "relative mt-4 lg:mt-0 col-12 lg:col-6 xl:col-7 z-40",
        leftContent: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "mb-10 lg:mb-10",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col justify-between rounded-full py-1 pr-1 text-sm lg:h-[50px] lg:flex-row lg:bg-white",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "flex flex-grow items-center lg:px-4",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
                id: "ipt-company-name",
                placeholder: "Your company name",
                className: "mb-4 w-full truncate rounded-full bg-white px-4 py-2 outline-none lg:mb-0",
                value: companyName,
                onChange: handleInput
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "lg:max-w-[237px]",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                onClick: function onClick() {
                  return handleSubmit();
                },
                className: "h-full w-full truncate rounded-full bg-bbc-primary py-2 px-6 text-base text-white",
                children: "Register Your Company"
              })
            })]
          })
        }),
        rightClassName: "static hidden lg:block lg:col-6 xl:col-5",
        rightContent: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
          children: screen === "DESKTOP" && /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
            wrapper: {
              className: "bbc-banner-image-bottom-0 banner-home"
            },
            className: "w-full",
            src: "/assets/images/sg/banner-sg-home.png",
            width: 1059,
            height: 815,
            alt: "register a company in Singapore with the help of technology",
            priority: true
          })
        }),
        wave: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "relative",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
            src: "/assets/images/wave/exclude-wave.svg",
            className: "h-full w-full",
            width: 1920,
            height: 95,
            wrapper: {
              className: "w-full h-full"
            },
            alt: "banner-img"
          })
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(IndustryNewsInsights/* default */.Z, {
      data: posts
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(AboutUs/* default */.Z, {
      data: data === null || data === void 0 ? void 0 : data.dataAboutUs,
      bgImage: "/assets/images/common/pexels-gradient.png"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(OurPartners/* default */.Z, {
      button: true
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
      className: "relative pt-10 lg:mb-0 lg:bg-bbc-brand-100 lg:pt-40 lg:pb-8",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
        className: "absolute  left-0 right-0 w-full",
        style: {
          top: "-4px"
        },
        src: "/assets/images/wave/curve_home-wave.svg",
        width: 1920,
        height: 158,
        wrapper: {
          className: "hidden lg:block"
        },
        alt: "wave3"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "container",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
          text: "Our Service",
          className: "mb-6 text-center text-bbc-30px font-semibold text-bbc-brand-800 lg:text-left lg:text-bbc-40px"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "text-center leading-bbc-26 text-bbc-gray lg:text-left",
          children: "We encompass well-rounded corporate services to boost your future growth. We offer various digital corporate services from easy company formation to professional post-incorporation services to help your Singapore business run smoothly during operations."
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "row items-center justify-between lg:mt-10",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "col-12 text-center lg:col-6",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
              src: "/assets/images/common/corporate_secretary-hk_sg.png",
              width: 540,
              height: 540,
              alt: "corporate-secretary"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "col-12 lg:col-5",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
                as: "h3",
                text: "Corporate Secretary",
                className: "mb-4 text-2xl font-semibold leading-9 text-bbc-brand-800 lg:mb-6 lg:text-bbc-30px"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "mb-6 leading-bbc-26",
                children: "Automate manual tasks with legal template and streamlined workflow. We help you keep focus on what matters to your business. And feel rest assured leaving the formalities to our qualified experts."
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "text-center lg:text-left",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
                  href: "/company-secretary",
                  className: "inline-block cursor-pointer rounded-[50px] border border-bbc-brand-500 py-2 px-6 font-semibold leading-bbc-26 text-bbc-brand-500 hover:bg-bbc-brand-500 hover:text-white",
                  children: "Explore"
                })
              })]
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "row mt-6 items-center justify-between lg:mt-10",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "col-12 order-2 mt-6 lg:col-5 lg:order-0 lg:mt-0",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
                as: "h3",
                text: "Company Incorporation",
                className: "mb-4 text-2xl font-semibold leading-9 text-bbc-brand-800 lg:mb-6 lg:text-bbc-30px"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "mb-6 leading-bbc-26",
                children: "Bring your business ideas to life and into motion with our innovative company formation services. We utilize scalable technology and industry network to help you go through incorporation with minimal effort and costs."
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "text-center lg:text-left",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
                  href: "/company-incorporation",
                  className: "inline-block cursor-pointer rounded-[50px] border border-bbc-brand-500 py-2 px-6 font-semibold leading-bbc-26 text-bbc-brand-500 hover:bg-bbc-brand-500 hover:text-white",
                  children: "Explore"
                })
              })]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "col-12 text-center lg:col-6",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
              src: "/assets/images/sg/home/company_formation-sg-home.png",
              width: 540,
              height: 540,
              alt: "company-formation"
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "row items-center justify-between lg:mt-10",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "col-12 text-center lg:col-6",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
              src: "/assets/images/common/business_accounts-hk_sg.png",
              width: 540,
              height: 540,
              alt: "business-accounts"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "col-12 lg:col-5",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
                as: "h3",
                text: "Business Accounts",
                className: "mb-4 text-2xl font-semibold leading-9 text-bbc-brand-800 lg:mb-6 lg:text-bbc-30px"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "mb-6 leading-bbc-26",
                children: "We make opening and sorting business bank account simple. Our banking consultations are designed to increase your chance of getting approval, prevent unnecessary paperwork, and reduce waiting time."
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "text-center lg:text-left",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
                  href: "/open-bank-account",
                  className: "inline-block cursor-pointer rounded-[50px] border border-bbc-brand-500 py-2 px-6 font-semibold leading-bbc-26 text-bbc-brand-500 hover:bg-bbc-brand-500 hover:text-white",
                  children: "Explore"
                })
              })]
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "row mt-6 items-center justify-between lg:mt-10",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "col-12 order-1 mt-6 lg:col-5 lg:order-0 lg:mt-0",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
                as: "h3",
                text: "Accounting & Auditing",
                className: "mb-4 text-2xl font-semibold leading-9 text-bbc-brand-800 lg:mb-6 lg:text-bbc-30px"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "mb-6 leading-bbc-26",
                children: "Eliminate time-consuming accounting tasks from your schedule and keep your tax compliance status green with our qualified accounting service."
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "text-center lg:text-left",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
                  href: "/accounting-and-auditing",
                  className: "inline-block cursor-pointer rounded-[50px] border border-bbc-brand-500 py-2 px-6 font-semibold leading-bbc-26 text-bbc-brand-500 hover:bg-bbc-brand-500 hover:text-white",
                  children: "Explore"
                })
              })]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "col-12 text-center lg:col-6",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
              src: "/assets/images/common/accounting_auditing-hk_sg.png",
              width: 540,
              height: 479,
              alt: "accounting-auditing"
            })
          })]
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "mb-20 hidden lg:block",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
        className: "w-full",
        src: "/assets/images/wave/curve_home1-wave.svg.svg",
        width: 1920,
        height: 116,
        wrapper: {
          className: "hidden lg:block"
        },
        alt: "wave4"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "col-12 m-auto lg:col-10",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Title/* default */.Z, {
            className: "title-h2 mb-6 pb-0 text-center text-bbc-brand-800",
            children: ["Don't just take our words. ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "Hear what our clients say"]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            className: "text-center",
            children: ["Clients talked about us on", " ", /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              className: "font-medium text-bbc-primary hover:text-bbc-secondary-300",
              target: "_blank",
              rel: "noreferrer",
              href: "https://www.trustpilot.com/review/bbcincorp.com",
              children: "Trustpilot"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(TrustpilotFeedBack/* default */.Z, {
            data: trustpilot_data/* feedback */.I
          })]
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormNewsletter/* default */.Z, {
      bgColor: "bg-bbc-gradient-9"
    })]
  });
};

/* harmony default export */ var sg = (Component);
Component.defaultProps = {
  data: {},
  posts: []
};
;// CONCATENATED MODULE: ./pages/sg/data.json
var sg_data_namespaceObject = JSON.parse('{"dataAboutUs":{"title":"Get to know us","description":"<p class=\\"mb-4\\"><span class=\\"text-bbc-secondary-300\\">BBCIncorp Limited </span> was established in 2017 with a mission to help startups and SMEs to free their resources tied up to intimidating company administration tasks, and thus speed up the process of setting up and running a business.</p><p>We know how hard it is for businesses to change in a fast-moving world, that\'s why we make it our vision from day one to deliver services that scale with time. With our proven IT infrastructure and commitment to being a digital-first service provider, we can get your company set up and managed properly in over +18 countries at minimum costs and in a reliable manner.</p>"}}');
;// CONCATENATED MODULE: ./pages/sg/index.js





var __N_SSG = true;
function Home(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Layout/* default */.Z, {
      locationRouter: "sg",
      page: data.page,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(sg, {
        posts: data === null || data === void 0 ? void 0 : data.posts,
        data: sg_data_namespaceObject
      })
    })
  });
}

/***/ }),

/***/ 3413:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sg",
      function () {
        return __webpack_require__(55613);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,3105,9593,9885,8352,8528,4090,9738,7447,2314,5111,2888,179], function() { return __webpack_exec__(3413); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);